import type { ReferencedEntry } from 'contentful';

import { fetchEntries } from 'api/contentful/fetchEntries';
import { get, getField, isEntry } from 'utils/EntryUtil';
import { useQuery } from '@tanstack/react-query';
import { DEFAULT_LANGUAGE_CODE, LanguageCode } from 'utils/Locales';
import { processCookiesForAnalytics } from 'services/analytics/analytics';
import { ClientConfig, ContentType } from 'api/contentful/contentTypes.cloverdotcom';
import { useState } from 'react';

export const fetchClientConfig = async (locale: string) => {
  const cookieConfigs = await fetchEntries<ClientConfig>(locale, {
    contentType: ContentType.CLIENT_CONFIG,
    include: 2,
  });

  const [entry] = get(cookieConfigs, 'items', []);

  if (isEntry(entry)) {
    return entry as ReferencedEntry<ClientConfig>;
  } else {
    throw new Error('Failed to fetch a valid client config from cloverdotcom contentful space');
  }
};

export const useCookieConfig = (locale: LanguageCode = DEFAULT_LANGUAGE_CODE) => {
  const { data: clientConfig } = useQuery(['clientConfig', locale], async () => fetchClientConfig(locale));
  const [hasProcessedCookies, setHasProcessedCookies] = useState(false);

  const cookieConfig = getField(clientConfig, 'cookieConfig');
  if (cookieConfig && !hasProcessedCookies) {
    processCookiesForAnalytics(cookieConfig);
    setHasProcessedCookies(true);
  }

  return cookieConfig ?? [];
};
